import ClientModel             from 'Models/directory/ClientModel';
import BillingFrequencyModel   from 'Models/invoice/BillingFrequencyModel';
import BillingGroupStatusModel from 'Models/invoice/BillingGroupStatusModel';
import BillingGroupTypeModel   from 'Models/invoice/BillingGroupTypeModel';
import BillingOwnerModel       from 'Models/invoice/BillingOwnerModel';
import DueDateTypeModel        from 'Models/invoice/DueDateTypeModel';
import InvoicingGroupModel     from 'Models/invoice/InvoicingGroupModel';
import PaymentModeModel        from 'Models/invoice/PaymentModeModel';
import SourceModel             from 'Models/invoice/SourceModel';
import doc                     from 'decorators/doc';
import model                   from 'decorators/model';
import { Timestampable }       from 'helpers/traits';
import { Blamable }            from 'helpers/traits';
import InvoicePrivateApiModel  from 'modelx/models/abstracts/InvoicePrivateApiModel';

@model.staticLabel('Période de facturation')
@model.urnResource('billing_group')
@doc.path('/billing_groups/{?id}')
export default class BillingGroupModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'billables': id;
		'billables.billableItems.billableItemMetas.reference': InvoiceBillableItemMetaReference;
		'billables.billableItems.billableItemMetas.value': id;
		'billables.billableItems.ownerLocation.locationUrn': Urn;
		'billables.billableStatus': id;
		'billables.billableStatus.reference': InvoiceBillableStatusReference;
		'billables.invoiceableAt[after]': string;
		'billables.invoiceableAt[before]': string;
		'billables.invoiceableAt[strictly_after]': string;
		'billables.invoiceableAt[strictly_before]': string;
		'billingGroupMetas.reference': InvoiceBillingGroupMetaReference;
		'billingGroupMetas.value': id;
		'billingGroupType': id;
		'billingGroupType.reference': InvoiceBillingGroupTypeReference;
		'billingOwner.clientUrn': Urn;
		'billingOwner.companyUrn': Urn;
		'billingOwner.invoicingOwner.enterpriseGroupUrn': Urn;
		'billingOwner.invoicingOwner.enterpriseUrn': Urn;
		'billingOwner.ownerSubPartition': id;
		'billingOwner.ownerSubPartition.partitionUrn': Urn;
		'billingOwner.ownerSubPartition.subPartitionUrn': Urn;
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'exists[billables.sourceUrn]': boolean;
		'invoices.billingPeriod': id;
		'invoicingGroup': id;
		'invoicingGroup.invoicingOwner.enterpriseGroupUrn': Urn;
		'invoicingGroup.invoicingOwner.enterpriseUrn': Urn;
		'sourceUrn': Urn;
		'updatedAt[after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'updatedAt[strictly_before]': string | Date;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'updatedAt': string;
	}> = {};

	@doc.model(BillingFrequencyModel) declare billingFrequency: BillingFrequencyModel;
	@doc.model(BillingGroupStatusModel) declare billingGroupStatus: BillingGroupStatusModel;
	@doc.model(BillingGroupTypeModel) declare billingGroupType: BillingGroupTypeModel;
	@doc.model(BillingOwnerModel) declare billingOwner: BillingOwnerModel;
	@doc.modelUrn(ClientModel) declare client: ClientModel;
	@doc.number declare dueDateDelay: number;
	@doc.model(DueDateTypeModel) declare dueDateType: DueDateTypeModel;
	@doc.string declare freeReference: string;
	@doc.model(InvoicingGroupModel) declare invoicingGroup: InvoicingGroupModel;
	@doc.string declare name: string;
	@doc.string declare note: string;
	@doc.model(PaymentModeModel) declare paymentMode: PaymentModeModel;
	@doc.modelUrn(SourceModel) declare source: SourceModel;
}
